/**
 * SiteAnalyticsTracker — Phase 122. Mount once inside <BrowserRouter>; fires
 * one first-party page-view beacon per route change on public pages.
 * Renders nothing.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@/lib/siteAnalytics';

export const SiteAnalyticsTracker = () => {
    const { pathname, search } = useLocation();
    useEffect(() => {
        trackPageview(pathname, search);
    }, [pathname, search]);
    return null;
};

export default SiteAnalyticsTracker;
